import React from 'react';
import { useTranslation } from 'react-i18next';
import { AvailablePopups } from 'store/app/types';
import Popup from 'components/Common/Popup/Popup';
import { WALLPAPER_PRODUCT_TYPES } from 'constants/app';
import { useSelector } from 'react-redux';
import getProductItem from 'store/product/selector/getProductItem';
import ProductAttributesPlacementContext, {
  AttributeSelectorPlacement,
} from 'context/ProductAttributesPlacementContext';
import styles from './AttributeSelectionMobilePopup.module.scss';
import ProductAttributes from '../ProductAttributes/ProductAttributes';
import BundleProducts from '../BundleProducts/BundleProducts';
import ProductPrice from '../ProductPrice/ProductPrice';
import AddToBasketButtonPremium from '../AddToBasketButtonPremium/AddToBasketButtonPremium';

const AttributeSelectionMobilePopup = () => {
  const { t } = useTranslation();
  const productItem = useSelector(getProductItem);
  const isWallpaper = WALLPAPER_PRODUCT_TYPES.includes(productItem?.product.productTypeId || -1);
  const isCuratedWallPaperDesign = productItem?.product.productTypeId === 176;
  const addToBasketButtonText = isCuratedWallPaperDesign ? t('txt_fit_to_wall') : undefined;
  const priceRemark = isWallpaper ? '*' : '';

  return (
    <Popup
      popupId={AvailablePopups.attributeSelectionMobilePopup}
      wrapperClassName={styles.popupWrapper}
      contentClassName={styles.popupContent}
      closeIconInContent
    >
      <div className={styles.attributeSelectionMobilePopup}>
        <ProductAttributesPlacementContext.Provider value={AttributeSelectorPlacement.POPUP}>
          <ProductAttributes />
        </ProductAttributesPlacementContext.Provider>
        <BundleProducts showDescription={false} />
        <ProductPrice remark={priceRemark} inOneLine />
        <AddToBasketButtonPremium primary buttonTitle={addToBasketButtonText} />
      </div>
    </Popup>
  );
};

export default AttributeSelectionMobilePopup;
